define('home/models/SettingsSocialAccount',[
    'core/config',

    'home/models/common/BaseSettings',
], function (
    config,

    BaseSettings
) {
    'use strict';

    var SettingsSocialAccount = BaseSettings.extend({
        url: function () {
            return config.urls.oauthStatus(this.id);
        },

        destroyUrl: function () {
            return config.urls.oauthDestroy(this.id);
        },

        destroy: function (options) {
            options = options || {};
            options.method = 'POST';
            options.url = this.destroyUrl();
            return BaseSettings.prototype.destroy.call(this, options);
        },

        toJSON: function () {
            return {
                'display_name': this.get('display_name'),
                'url': this.get('url'),
            };
        },
    });

    return SettingsSocialAccount;
});


